import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'company-roles-and-permission',
  templateUrl: './company-roles-and-permissions.component.html',
  styleUrl: './company-roles-and-permissions.component.scss',
  standalone: false,
})
export class CompanyRolesAndPermissionComponent {
  constructor(private readonly activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close();
  }
}
